import Route from './models/Route'
import { loadRoute } from '@/api/route'

export default {

  namespaced: true,

  state: {
    route: new Route
  },

  mutations: {
    ...Route.mutations()
  },

  actions: {
    loadRoute: ({commit}, routeId) => new Promise((resolve, reject) => {
      loadRoute(routeId, ({data}) => {
        commit('setRoute', data)
        resolve()
      }, reject)
    })
  },

  getters: {
    route: state => state.route
  }

}
